
  
  export const coreteamprofile = [
    {
      id: 1,
      name: "Mr. Sanjay Chittore",
      img: require("../../src/Images/SANJAY.png"),
      linkedin: "https://www.linkedin.com/in/sanjaychittore/",
      title: "Founder & CEO",
    },
    {
      id: 2,
      name: "Mr. Kapil Jaiswal",
      img: require("../../src/Images/KAPIL.png"),
      linkedin: "https://www.linkedin.com/in/k-jaiswal/",
      title: "CTO",
    },

    {
      id: 3,
      name: "Dr. Sachin Barthwal",
      img: require("../../src/Images/SACHIN.png"),
      linkedin: "https://www.linkedin.com/in/sachin-barthwal-38190322a/",
      title: "Quantum Product Head",
    },
    {
      id: 4,
      name: "Dr. Diksha Sharma",
      img: require("../../src/Images/DIKSHA.png"),
      linkedin: "https://www.linkedin.com/in/diksha-sharma-065780a9/",
      title: "Quantum Research Scientist",
    },
    {
      id: 5,
      name: "Dr. Monika",
      img: require("../../src/Images/MONIKA.png"),
      linkedin: "https://www.linkedin.com/in/dr-monika-thakran-1695762b5/",
      title: "Quantum Sensing Lead",
    },
    {
      id: 6,
      name: "Dr. Avinash Kumar",
      img: require("../../src/Images/AVINASH KUMAR.png"),
      linkedin: "https://www.linkedin.com/in/avinash-kumar-phd-05791a183/",
      title: "Quantum Optics Scientist",
    },
    {
      id: 7,
      name: "Dr. Dhanshree Thulkar",
      img: require("../../src/Images/DHANSHREE.png"),
      linkedin: "https://www.linkedin.com/in/dhanshree-thulkar-phd-2960763a/",
      title: "Head of Product Management",
    },
    {
      id: 8,
      name: "Ms. Gopika Chaganti",
      img: require("../../src/Images/GOPIKA.png"),
      linkedin: "https://www.linkedin.com/in/gopika-chaganti/",
      title: "COO of QuAcademy ",
    },
    {
      id: 9,
      name: "Mrs. Diana Dsouza",
      img: require("../../src/Images/DIANA.png"),
      linkedin: "https://www.linkedin.com/in/diana-d%E2%80%99souza-56b58b42/",
      title: "Head of Sales and Business Development",
    },

    // {
    //   id:5,
    //   name:"Dr. Avinash Chalumuri",
    //   img:require("../../src/Images/AVINASH.png"),
    //   linkedin:"https://www.linkedin.com/in/avinash-chalumuri-phd-57ab2616b/",
    //   title:"AI/QML Scientist"
    // },
    // {
    //   id: 10,
    //   name: "Mr. Rikteem Bhowmick",
    //   img: require("../../src/Images/RIKTHIM.png"),
    //   linkedin: "https://www.linkedin.com/in/rikteem-bhowmick-aa3050228/",
    //   title: "Head of Quantum Communication",
    // },
    // {
    //   id: 11,
    //   name: "Mr. Devendra Mishra",
    //   img: require("../../src/Images/DEVENDER.png"),
    //   linkedin: "https://www.linkedin.com/in/devendra-mishra444/",
    //   title: "Head of Quantum Hardware",
    // },

    // {
    //   id: 7,
    //   name: "Dr. Bappaditya Sankhari",
    //   img: require("../../src/Images/BAPPA.png"),
    //   linkedin: "https://www.linkedin.com/in/bappaditya-sankhari-6b5268a8/",
    //   title: "Head of Quantum Architecture",
    // },
    {
      id: 10,
      name: "Mr. Rama Theja",
      img: require("../../src/Images/RAM THEJA.png"),
      linkedin: "https://www.linkedin.com/in/ramatheja/",
      title: "Head Opto Electronics",
    },
    {
      id: 11,
      name: "Mr. Neelesh Singh Katoch",
      img: require("../../src/Images/NEELESH.png"),
      linkedin: "https://www.linkedin.com/in/neelesh-katoch/",
      title: "Quantum Software Engineer",
    },
  ];


  
  export const advisoryprofile = [
    // {
    //     id: 1,
    //     name: "Dr Satya",
    //     img: require("../../src/Images/SATYA.png"),
    //     linkedin: "https://www.linkedin.com/in/chickerursr/",
    //     title:"",

    //   },
    //   {
    //     id: 2,
    //     name: "Subodh Bijwe",
    //     img: require("../../src/Images/SUBODH.png"),
    //     linkedin: "https://www.linkedin.com/in/subodh-bijwe-37057610a/",
    //     title:"",

    //   },

    {
      id: 1,
      name: "Prof. Anil Prabhakar",
      linkedin: "https://in.linkedin.com/in/dr-kishore-sonti-347b23133",
      title: "Quantum Professor, IIT Madras", // Innovation and Technology Advisor
    },
    {
      id: 2,
      name: "Dr. Venkata Jaya Krishna Kishore",
      linkedin: "https://in.linkedin.com/in/dr-kishore-sonti-347b23133",
      title: "Pro Vice-Chancellor, Jeppiaar University", // Innovation and Technology Advisor
    },
    {
      id: 3,
      name: "Prof. Sugata Gangopadhyay",
      linkedin: "https://www.linkedin.com/in/sugata-gangopadhyay-08354219/",
      title: "Head of the Department, CSE, IIT Roorkee",
    },
    {
      id: 4,
      name: "Prof.M.V.Panduranga Rao",
      linkedin: "",
      title: "Associate professor, CSE, IIT Hyderabad",
    },
    {
      id: 5,
      name: "Prof. Arijit Sharma",
      linkedin: "https://www.linkedin.com/in/arijit-sharma-4261a923/",
      title: "Assistant Professor. IIT Tirupati",
    },
    {
      id: 6,
      name: "Mr. Naresh Kumar Emani",
      linkedin: "https://www.linkedin.com/in/naresh-kumar-emani-a9b9377/",
      title: "Associate Professor, EEE, IIT Hyderabad",
    },
    {
      id: 7,
      name: "Mr. Sai Santosh Kumar Raavi",
      linkedin: "https://www.linkedin.com/in/sai-santosh-kumar-raavi-28715882/",
      title: "Professor, Physics, IIT Hyderabad",
    },
    {
      id: 8,
      name: "Prof.Ajay Wasan",
      linkedin: "https://www.linkedin.com/in/ajay-wasan-15116aa/",
      title: "Professor, IIT Roorke",
    },
    {
      id: 9,
      name: "Prof. Debabrata Goswami",
      linkedin: "https://www.linkedin.com/in/debabrata-goswami-a453014/",
      title: "Professor, Quantum Computing, IIT Hyderabad",
    },
    {
      id: 10,
      name: "Dr. Mansi Dhuria",
      linkedin: "https://www.linkedin.com/in/dr-mansi-dhuria-633a79125/",
      title: "Assistant Professor, PDEU Gandhinagar",
    },
    {
      id: 11,
      name: "Dr Ravi Sarepalli",
      // img: require("../../src/Images/RAVISARIPALLE.png"),
      linkedin: "https://www.linkedin.com/in/ravisaripalle/",
      title: "Professor of Entrepreneurship, GITAM Hyderabad",
    },
    {
      id: 12,
      name: "Dr Hemachandran",
      // img: require("../../src/Images/HEMACHANDRAN.png"),
      linkedin: "https://www.linkedin.com/in/drhemachandrank/",
      title: "Enterprise Risk Advisor, Univesity of St Thomas, USA",
    },
    {
      id: 13,
      name: "Dr. Aishik Acharya",
      // img: require("../../src/Images/ACHARYA.png"),
      linkedin: "https://www.linkedin.com/in/dr-aishik-acharya-7a717287/",
      title: "Senior Scientist, CQuERE",
    },

    {
      id: 14,
      name: "Dr Satyadhyan Chickerur",
      // img: require("../../src/Images/SATYA.png"),
      linkedin: "https://www.linkedin.com/in/chickerursr/",
      title: "Artificial Intelligence Research (CAIR), KLE Univesity",
    },
    {
      id: 15,
      name: "Karthiganesh Dura",
      // img: require("../../src/Images/KARTHIGANESH.png"),
      linkedin: "https://www.linkedin.com/in/karthiganesh-durai-95535872/",
      title: "Founder/CEO, KwantumG Research Labs",
    },
    
  ];
  
  